import React, {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';
import GC from '@mescius/spread-sheets';
import { useStateWithGetter } from '../../utils/useStateWithGetter';

type SpreadContextProps = {
  selectedShape: GC.Spread.Sheets.Shapes.Shape | null;
  setSelectedShape: Dispatch<
    SetStateAction<GC.Spread.Sheets.Shapes.Shape | null>
  >;
  spread: GC.Spread.Sheets.Workbook | null;
  setSpread: Dispatch<SetStateAction<GC.Spread.Sheets.Workbook | null>>;
  isDirtyToSpread?: boolean;
  setIsDirtyToSpread: Dispatch<SetStateAction<boolean>>;
  getIsDirtyToSpread: () => boolean;
  isDetail?: boolean;
  setIsDetail: Dispatch<SetStateAction<boolean>>;
  getIsDetail: () => boolean;
  isSelectingLoopHeaderRow: boolean;
  setIsSelectingLoopHeaderRow: Dispatch<SetStateAction<boolean>>;
};

const SpreadContext = createContext<SpreadContextProps>({
  selectedShape: null,
  setSelectedShape: () => {},
  spread: null,
  setSpread: () => {},
  isDirtyToSpread: false,
  setIsDirtyToSpread: () => {},
  getIsDirtyToSpread: () => false,
  isDetail: false,
  setIsDetail: () => {},
  getIsDetail: () => false,
  isSelectingLoopHeaderRow: false,
  setIsSelectingLoopHeaderRow: () => {},
});

/**
 *
 * @param { ReactNode } children
 * @returns
 */
export function SpreadProvider({
  children,
}: {
  children: ReactNode;
}): React.JSX.Element {
  const [selectedShape, setSelectedShape] =
    useState<GC.Spread.Sheets.Shapes.Shape | null>(null);

  // Spread.jsのWorkbookオブジェクト
  const [spread, setSpread] = useState<GC.Spread.Sheets.Workbook | null>(null);

  // シートが編集されたかどうかのフラグ
  const [isDirtyToSpread, setIsDirtyToSpread, getIsDirtyToSpread] =
    useStateWithGetter<boolean>(false);

  // 詳細表示かどうかのフラグ
  const [isDetail, setIsDetail, getIsDetail] =
    useStateWithGetter<boolean>(true);
  const [isSelectingLoopHeaderRow, setIsSelectingLoopHeaderRow] =
    useState(false);

  return (
    <SpreadContext.Provider
      value={{
        selectedShape,
        setSelectedShape,
        spread,
        setSpread,
        isDirtyToSpread,
        getIsDirtyToSpread,
        setIsDirtyToSpread,
        isDetail,
        setIsDetail,
        getIsDetail,
        isSelectingLoopHeaderRow,
        setIsSelectingLoopHeaderRow,
      }}
    >
      {children}
    </SpreadContext.Provider>
  );
}

export const useSpread = () => useContext(SpreadContext);
